module.exports = __webpack_public_path__ + "img/token-icon.5d911359.svg";